module.exports = __webpack_public_path__ + "static/media/power_systems_icon-color.484bc78c.svg";